import { render, staticRenderFns } from "./UserApprovalRequests.vue?vue&type=template&id=ed4d6892"
import script from "./UserApprovalRequests.vue?vue&type=script&lang=js"
export * from "./UserApprovalRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports